import React from 'react'
import { Box, Grid, LinearProgress, Typography, makeStyles } from '@material-ui/core'

function LeadershipCompetency() {
    return <Box >
        <Grid container direction="row">

            <Grid item xs={12}>
                <Typography variant="h3" style={{ color: "#232323" }}>
                    <Box textAlign="left" mt={2} fontWeight="fontWeightBold">
                        Leadership Competency Objective 1
                    </Box>
                </Typography>
                <Typography variant="h5" style={{ color: "#707070CC" }}>
                    <Box textAlign="left" mt={1}>
                        Continuously improve & Innovate
                    </Box>
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h3" style={{ color: "#232323" }}>
                    <Box textAlign="left" mt={2} fontWeight="fontWeightBold">
                        Leadership Competency Objective 2
                    </Box>
                </Typography>
                <Typography variant="h5" style={{ color: "#707070CC" }}>
                    <Box textAlign="left" mt={1}>
                        See more in others
                    </Box>
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h3" style={{ color: "#232323" }}>
                    <Box textAlign="left" mt={2} fontWeight="fontWeightBold">
                        Leadership Competency Objective 3
                    </Box>
                </Typography>
                <Typography variant="h5" style={{ color: "#707070CC" }}>
                    <Box textAlign="left" mt={1} mb={3}>
                        Build for the Long Term
                    </Box>
                </Typography>
            </Grid>
        </Grid>
    </Box>
}

export default LeadershipCompetency
